import React from 'react'
import { ReactComponent as FacebookSvg } from 'resources/svg/social/facebook.svg'
import { ReactComponent as PinterestSvg } from 'resources/svg/social/pinterest.svg'
import { ReactComponent as TwitterSvg } from 'resources/svg/social/twitter.svg'
import { Container } from './styled'

interface Props {
  title?: string
}

export const SocialShare: React.FC<Props> = ({ title }) => {
  const links = [
    {
      url: `https://www.facebook.com/sharer.php?u=${window.location.href}`,
      svgComponent: FacebookSvg,
      class: 'icon-facebook'
    },
    {
      url: `https://pinterest.com/pin/create/link/?url=${window.location.href}`,
      svgComponent: PinterestSvg,
      class: 'icon-pinterest'
    },
    {
      url: `https://twitter.com/intent/tweet?url=${window.location.href}&text=${title}`,
      svgComponent: TwitterSvg,
      class: 'icon-twitter'
    }
  ]

  return (
    <Container>
      <div>
        <span>Share</span>
      </div>
      <ul>
        {links.map(link => (
          <li
            key={link.url}
          >
            <a
              href={link.url}
              target='_blank'
              rel='noopener noreferrer'
              className={link.class}
            >
              <link.svgComponent />
            </a>
          </li>
        ))}
      </ul>
    </Container>
  )
}
